import { FC } from 'react'

import { ConfirmDialog } from '@/components'

import { OPS_BULK_CLEAR_CACHE_LABEL, OPS_BULK_REDEPLOY_LABEL } from './opsUiShared'

type BulkActionConfirmModalProps = {
  visible: boolean
  actionType: 'redeploy' | 'clear-cache' | null
  groupName: string
  storeCount: number
  isLoading?: boolean
  onConfirm: () => void
  onHide: () => void
}

const BulkActionConfirmModal: FC<BulkActionConfirmModalProps> = ({
  visible,
  actionType,
  groupName,
  storeCount,
  isLoading,
  onConfirm,
  onHide,
}) => {
  const actionLabel = actionType === 'clear-cache' ? 'purge cache for' : 'publish'
  const storeLabel = `${storeCount} active store${storeCount !== 1 ? 's' : ''}`
  const headerTitle =
    actionType === 'clear-cache'
      ? `Confirm ${OPS_BULK_CLEAR_CACHE_LABEL}`
      : actionType === 'redeploy'
        ? `Confirm ${OPS_BULK_REDEPLOY_LABEL}`
        : 'Confirm action'

  return (
    <ConfirmDialog
      visible={visible}
      closeOnBackdrop={false}
      headerTitle={headerTitle}
      confirmText={
        <>
          This will {actionLabel} {storeLabel} in{' '}
          <span className="font-semibold text-gray-700">{groupName}</span>. Do you want to continue?
        </>
      }
      isLoading={isLoading}
      onConfirm={onConfirm}
      onHide={onHide}
    />
  )
}

export { BulkActionConfirmModal }
